/* src/app/shared/dialog/tv-select-pack-channels-dialog/tv-select-pack-channels-dialog.component.scss */
.container-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 450px;
  margin: 0;
  border-radius: 25px;
  font-size: 13px;
}
.container-options .mat-checkbox-inner-container {
  width: 12px;
  height: 12px;
}
.container-options .search-container {
  margin: 12px 0px;
}
.container-options .full-width {
  width: 100%;
}
.container-options .checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 250px;
  overflow-y: auto;
}
.container-options .button-group-horizontal {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}
.search-container {
  margin: 12px 0px;
}
.button-edit {
  justify-content: flex-end;
  display: inline-flex;
}
.tv-ns-secondary-large-button-on-light-bg {
  width: 150px;
  margin-right: 25px;
}
.tv-ns-validation-large-button {
  width: 150px;
}
.channel-logo {
  margin-right: 8px;
  width: 14px;
  height: auto;
}
.checkbox-input {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.channel-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}
.channel-name {
  font: 400 14px FranceTV Brown;
  color: #001A33;
}
.rate-cell {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
}
.rate-input-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 120px;
}
.rate-unit {
  font: 400 14px FranceTV Brown;
  color: #001A33;
  min-width: 16px;
  align-self: center;
}
.bloc-container-share {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.red-title-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  color: #F03C64;
}
.red-info-container {
  display: flex;
  flex-direction: row;
  gap: 2px;
}
.red-info-container .mat-icon {
  align-self: center;
  width: 15px;
  height: 15px;
  font-size: 14px;
  color: #F03C64;
}
.red-title {
  font: 400 14px FranceTV Brown;
  color: #F03C64;
}
/*# sourceMappingURL=tv-select-pack-channels-dialog.component.css.map */
